<!--How to use-->
<!--<Toggle v-model="toggleData" :text="'toggleText'"></Toggle>-->

<template>
  <div class="toggle-wrapper">
    <div class="toggle">
      <input type="checkbox" :id="'is-live-' + id" :checked="checked" @change="$emit('change', $event.target.checked)" :disabled="disabled"/>
      <label :for="'is-live-' + id">Toggle</label>
    </div>
    <span class="text" :class="{'online-text': checked, 'opacity-06': disabled}">{{ text }}</span>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  let id = 0;
  export default {
    name: 'toggle',
    components: {},
    model: {
      prop: 'checked',
      event: 'change'
    },
    props: {
      checked: {
        type: Boolean,
        default: false
      },
      text: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    beforeCreate () {
      this.id = (id++).toString();
    },
    data () {
      return {};
    },
    getters: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({})
    },
    computed: {}
  };
</script>


<style lang="less" scoped>
@import '../../styles/variables.less';

.toggle-wrapper {
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 4px;

  .text {
    color: @black-3;
    font-family: @font-family-main;
    font-size: 13px;
    line-height: 16px;

    &.online-text {
      color: @blue-2;
    }
  }

  .toggle {
    overflow: hidden;
    margin-right: 8px;

    input[type=checkbox] {
      //height: 0;
      width: 0;
      visibility: hidden;
    }

    label {
      float: left;
      cursor: pointer;
      text-indent: -9999px;
      width: 32px;
      height: 16px;
      background: #fff;
      border-radius: 24px;
      position: relative;
      top: 3px;
      left: 0;
      border: 1.5px solid rgba(0, 0, 0, 0.1) !important;
      margin-bottom: 0;
    }

    label:after {
      content: '';
      position: absolute;
      top: -0.7px;
      left: -0.7px;
      width: 14px;
      height: 14px;
      background: #fff;
      border-radius: 24px;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }

    input:checked + label {
      background: @blue-2;
      border: 2px solid @blue-2;
      // border: none;
    }

    input:checked + label:after {
      // top: -0.5px;
      left: calc(100% + 4px);
      transform: translateX(-100%);
      //box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
    }

    label:active:after {
      width: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Toggle.vue?850875c8